export const CHIP_GAP = 4;
export const CHIP_MEASURE_SELECTOR = '[data-chip]';

export function countFittingChips(container: HTMLElement, chipGap = CHIP_GAP): number {
  const chips = Array.from(
    container.querySelectorAll<HTMLElement>(CHIP_MEASURE_SELECTOR),
  );
  let used = 0;
  let count = 0;

  for (const chip of chips) {
    const width = chip.offsetWidth + (count > 0 ? chipGap : 0);

    if (used + width > container.clientWidth && count > 0) {
      break;
    }

    used += width;
    count++;
  }

  return count;
}

export function getVisibleChipCount(
  selectedCount: number,
  fitCount: number,
  maxVisibleChips?: number,
): number {
  if (maxVisibleChips != null) {
    return Math.min(maxVisibleChips, selectedCount);
  }

  return Math.min(fitCount, selectedCount);
}
